import React from 'react';
import './EditMenuIcon.scss';

const EditMenuIcon = () => {
    return (
        <div className="component-EditMenuIcon ">
            <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M13.8067 3.75335C14.0667 4.01335 14.0667 4.43335 13.8067 4.69335L12.5867 5.91335L10.0867 3.41335L11.3067 2.19335C11.5667 1.93335 11.9867 1.93335 12.2467 2.19335L13.8067 3.75335ZM2 14V11.5L9.37333 4.12669L11.8733 6.62669L4.5 14H2Z"
                        fill="#8E9DB9"
                    />
                </g>
            </svg>
        </div>
    );
};

EditMenuIcon.propTypes = {};

EditMenuIcon.defaultProps = {};

EditMenuIcon.displayName = 'EditMenuIcon';

export default EditMenuIcon;
